<swal
  #swal
  text="This cannot be undone"
  [showConfirmButton]="false"
  [customClass]="{ popup: 'custom-swal-popup PMethodinfo' }"
  [showCloseButton]="true"
>
  <div *swalPortal="undefined">
    <h2 class="swal2-title">
      {{ 'fe_step2_modal_paymethod_h2_title' | translate }}
    </h2>
    <p>{{ 'fe_step2_modal_paymethod_p_subtitle' | translate }}</p>

    <div class="modal__info">
      <div class="d-flex">
        <i class="discount-icon"></i>
        <p class="modal__subtitle text-start">
          <b>
            {{
              'fe_step2_modal_paymethod_p_subtitle_prepay' | translate
            }}
          </b>
        </p>
      </div>
      <p class="modal__description text-start">
        {{ 'fe_step2_modal_paymethod_p_description_prepay' | translate }}
      </p>
      <p class="modal__subtitle text-start">
        <b>{{ 'fe_step2_modal_paymethod_p_subtitle_office' | translate }}</b>
      </p>
      <p class="modal__description text-start">
        {{ 'fe_step2_modal_paymethod_p_description_office' | translate }}
      </p>
    </div>
  </div>
</swal>

